module.exports = __webpack_public_path__ + "media/configurations/ZOC_X-X-P-5061659f.png";